import React from 'react'
import injectStyles from 'react-jss'
import cn from 'classnames'
import { styles } from './style'
import { CAMPAIGN_INTERNAL_STATUSES } from '../../shared/constants'
import moment from 'moment'

const getStatusText = (status, isDeclined = false) => {
  switch (status) {
    case CAMPAIGN_INTERNAL_STATUSES.DRAFT: {
      return 'Draft'
    }
    case CAMPAIGN_INTERNAL_STATUSES.REJECTED: {
      return 'Action Required'
    }
    case CAMPAIGN_INTERNAL_STATUSES.IN_REVIEW: {
      return 'In Review'
    }
    case CAMPAIGN_INTERNAL_STATUSES.CODE_REVIEW:
    case CAMPAIGN_INTERNAL_STATUSES.GENERATING_DIGITAL_PROOF:
    case CAMPAIGN_INTERNAL_STATUSES.PAYMENT: {
      return 'Approved'
    }
    case CAMPAIGN_INTERNAL_STATUSES.ACTIVE: {
      return 'Active'
    }
    case CAMPAIGN_INTERNAL_STATUSES.COMPLETED: {
      return 'Completed'
    }

    default: {
      return status
    }
  }
}

const StatusLabelSelfServe = ({
  classes,
  status,
  isDeclined,
  reviewMeetingDate,
  cypress_id,
}) => {
  let text = getStatusText(status, isDeclined, cypress_id)
  let labelClass = {
    [classes.completed]: text === 'Completed',
    [classes.active]: text === 'Active',
    [classes.actionRequired]: text === 'Action Required',
    [classes.draft]: text === 'Draft',
    [classes.approved]: text === 'Approved',
    [classes.inReview]: text === 'In Review',
  }
  const shouldDisplayReviewBooked =
    reviewMeetingDate &&
    moment(reviewMeetingDate).isAfter(moment()) &&
    (status === CAMPAIGN_INTERNAL_STATUSES.DRAFT ||
      status === CAMPAIGN_INTERNAL_STATUSES.IN_REVIEW)

  if (shouldDisplayReviewBooked) {
    text = 'Review Booked'
    labelClass = { [classes.reviewBooked]: true }
  }

  return (
    <div className={cn(classes.wrap, labelClass)} cypress_id={cypress_id}>
      {text}
    </div>
  )
}

export default injectStyles(styles)(StatusLabelSelfServe)
